import homeColumn from "./home_columns";
import homeColumnTablet from "./home_columns_tablet";
import homeColumnMobile from "./home_columns_mobile";
import home_general from './home_general'

class home {
  constructor(){
    window.home = this;

    this.domob = $('.home--cols').hasClass('mobhome');
    this.dotablet = $('.home--cols').hasClass('tablet');
    // console.log('constructing', window.homeconstructed);
    if(!window.homeconstructed){
      this.scene = null;
      this.bound = false;
      window.homeSpeed = $('.home--cols').attr('data-speed');
      this.cols = $('.home--cols--col');

      window.homegeneral = new home_general();

      if(!MOBILE) {
        window.homegeneral.checkSplash();
        window.homegeneral.checkLogo();
      } else {
        $('.splashtext').remove();
        this.doAnimation();
      }
      $('.home--cols--col--text:not(.clonetitle)').empty();
    }
    this.binds();
  } // end constructor

  binds() {

    // if(!this.bound) {
      console.log('home binds');
      this.bound = true;

      $('a.projectlink').unbind('click').click(function(e) {
        e.preventDefault();
        var href = $(this).attr('href');
        console.log('click');
        e.stopPropagation();
        window.previousNavFrom = 'home';

        var tarText = $(this).parents('.home--cols--col').children('.home--cols--col--text');
        $(tarText).html($(this).html());

        $('.home--cols--col--text').not(tarText).css('opacity',0);

        // $(tarText).css('mix-blend-mode','normal');
        console.log(tarText);
        window.ajaxload(href, tarText.get(0));
        $(tarText).fadeOut(200);

        clearTimeout(window.notisInTimeout);
        if(window.notisInTimeoutNews){
          for(var n=0;n<window.notisInTimeoutNews.length;n++){
            clearTimeout(window.notisInTimeoutNews[n]);
            window.notisInTimeoutNews[n] = null;
          }
        }
        $('.noti:not(.keksi)').removeClass('in');
      });

      // if(!MOBILE) {
      $('.home--biglink').unbind('click mouseenter mouseleave').click(function(e){
        e.preventDefault();
        window.projectlinkclick = true;
        $(this).parents('.home--col--block').find('.projectlink').click();
      }).mouseenter(function(){
        if(!window.preventTitleHovers){
          var t = $(this).parents('.home--col--block').find('.projectlink').html();
          $(this).parents('.home--cols--col')
          .children('.home--cols--col--text')
          .html(t);
        }
      }).mouseleave(function(){
        if(!window.projectlinkclick){
          $(this).parents('.home--cols--col').children('.home--cols--col--text').empty();
        }
      });
      // } else {
      if(this.domob) {
        $('.home--biglink').unbind('mouseenter mouseleave')
      }
    // }
  }

  checkLogo(){
    if(window.localStorage.getItem('note-home-biglogo')){
      var diff = (Date.now() - parseInt(window.localStorage.getItem('note-home-biglogo'))) / 1000;
      console.log(diff);
      let fivemin = 300;
      if(diff > fivemin) {
        // has passed
        console.log('has passed');
        this.doLogo();
      } else {
        // hasnt passed
        console.log('hasnt passed');
      }
    } else if (window.localStorage.getItem('note-home-splash')){
      // console.log('dafuq');
    }
  }

  doAnimation() {
    console.log('doing animation');
    var home = this;
    window.homeconstructed = true;

    $('html').addClass('splashdone');

    $('.header').css('opacity',1);
    $('.menu-button').addClass('in');

    $('.menu-button').addClass('noanim');


    setTimeout(function(){
      window.homegeneral.runNotis();

      $('.header').removeClass('huge');

      window.notitimeout = setTimeout(function(){
        $('.noti.news').removeClass('in');
      }, 8000);

      $('.noti').mouseenter(function(){
        clearTimeout(window.notitimeout);
      });
    }, 2000);

    setTimeout(function(){
      window.runKeksi();
    }, 3000);

    // $('.splashtext').remove();

    // setTimeout(function(){
    // }, 600);
    // $('.splashtext').slideUp(200);

    $('.home--cols').show();

    $('.floaters--item').each(function(){
      var x = Math.random()*20 - 10+'%';
      var y = Math.random()*10 - 5+'%';
      var clone = $(this).clone();
      $(clone).css('opacity', 0);
      $(clone).find('img').css({
        'transform' : 'scale(1.2) translate3d('+x+','+y+',0)'
      });
      $(clone).appendTo($('.home--absolute--floaters'));
    });

    $('.home--cols--col--text').show(); // because if clicked they are fadeOuted

    // load all on pageload
    // $(window).load(function(){
    console.log('load pageshow');
    $('[data-src]:not(.ok):not(.loading)').each(function(){
      let src = $(this).attr('data-src');
      // let srcset = $(this).attr('data-srcset');
      let srcset = $(this).attr('data-srcset');
      // if(!WEBP) {
      //   srcset = $(this).attr('data-srcset-jpeg');
      // }

      if($(this).is('video')) {
        // console.log(this, src);
        var t = this;
        setTimeout(function(){
          $(t).addClass('loading').attr({
            'src' : src,
          });
        }, 1);
      } else {
        $(this).addClass('loading').attr({
          'src' : src,
          'srcset' : srcset,
        });
      }

      var t = $(this).get(0);
      if(t.complete) { $(t).addClass('ok').removeClass('loading'); }
      t.onload = function(){ $(t).addClass('ok').removeClass('loading'); }
      t.onloadeddata = function(){ $(t).addClass('ok').removeClass('loading'); }
    });

    if(this.domob) {
      for(var i=0; i<home.cols.length;i++) {
        if(this.dotablet) {
          this.scene = new homeColumnTablet(home.cols[i]);
          this.scene.checkFloaters();
        } else {
          this.scene = new homeColumnMobile(home.cols[i]);
          this.scene.checkFloaters();
        }
      }
    } else {
      window.home.scene = {
        run: true,
        cols: [],
      }
      for(var i=0; i<window.home.cols.length;i++) {
        let newCol = new homeColumn(home.cols[i]);
        newCol.checkFloaters();
        window.home.scene.cols.push(newCol);
      }

      var parent = this;
      gsap.ticker.add(() => {
        if(window.home.scene.run) {
          window.scrubvarsoffset -= .00004 * window.homeSpeed;
          for(var i=0; i<window.home.scene.cols.length;i++) {
            let parent = window.home.scene.cols[i];
            parent.scrub.vars.offset = ((parent.iteration + parent.trigger.progress) * parent.seamlessLoop.duration()) + window.scrubvarsoffset;
            parent.scrub.invalidate().restart();
            parent.checkFloaters();
          }
          // if(MOBILE){
          //   parent.checkMobile();
          // }
        }
        // this.trigger.update();
      });
      gsap.ticker.fps(60);

      /*
      $(window).on('resize', function(){
        for(var i=0;i<home.scene.cols.length;i++){
          let floats = home.scene.cols[i].floaterBlocks;
          for(var f=0;f<floats.length;f++){
            floats[f].doFirstCheck = true;
          }
        }
      });
      */
    }

    $('.home--cols').addClass('in').css('opacity',1);

  }
} export default home;
